
import {accessibilityTemplate} from 'a_root-folder/lib/service/modal/templates/accessibility';
import './style.scss';

import EventEmitter from 'lib/helpers/EventEmmiter';
import {setVoiceOverFocus} from "lib/service/html.service";

export default class Accessibility extends EventEmitter{
    events = {
        'keypress': this.keyPressHandler
    }
    active = {
        hotspot: false
    }
    modal = null;
    _stepClickCount = 0;
    _onWaitEnter = null;

    constructor({modalService, container, translateService}) {
        super();

        this._container = container
        this._modalService = modalService;
        this._translateService = translateService;

        this._setHotspot();
        this._initListener();
        this._createModal();
    }

    keyPressHandler(event) {
        if(this._onWaitEnter && event.key === "Enter"){
            this._fireEvent('change.scene', this._onWaitEnter);
            this._onWaitEnter = null;
        }
        
        this._hostpots.forEach((el) => {
            const hotspot = el.parentNode;
            const title = hotspot.querySelector('.pnlm-hotspot-title').parentNode;
            title.classList.remove('blink-effect');

            const {id, sceneID} = el.dataset;
            if(id === event.key){
                title.focus();
                title.classList.add('blink-effect');
                this._onWaitEnter = sceneID;
                setVoiceOverFocus(hotspot);

                // this._fireEvent('change.scene', sceneID);
            }
        });
    }

    _setHotspot(){
        this._hostpots = this._container.querySelectorAll('.accessibility-hotspot');
    }

    _initListener(){
        for(let i in this.events){
            document.addEventListener(i, this.events[i].bind(this));
        }
    }

    _removeListener(){
        for(let i in this.events){
            document.removeEventListener(i, this.events[i].bind(this));
        }
    }

    toogleModal(e){
        if(this.modal) return this._hideModal(e);

        this._createModal();
    }

    _hideModal(e){
        if(!this.modal) return;

        this._modalService.close(this.modal, e);
        this.modal = null;
    }
    
    _createModal(){
        const onCalback = (name, ...arg) => {
            this.active[name] = !this.active[name]
            this._fireEvent(name, ...arg);
            this[name](name, ...arg);
        }
        this.modal = this._modalService.showCreatedModal('modal_accessibility', accessibilityTemplate(onCalback, this._translateService), true, {
            'chat-modal-close': (e) => {
                this._modalService.close(this.modal, e);
            }
        });
    }

    onSceneChange() {
        if(this.active['hotspot']){
            this._setHotspot();
            this.hotspot();
        }
    }

    enlarge_cursor() {
        document.body.classList.toggle('enlarge_cursor');
        this._modalService.close(this.modal, null);
    }

    desaturate() {
        document.body.classList.toggle("desaturate");
    }

    autorotate_on() {
        this._modalService.close(this.modal, null);
    }

    moveSteps(e) {
        const steps = e.currentTarget.querySelectorAll('.steps-wrapper .steps')

        steps.forEach((step) => {
            step.classList.remove('active');
        });
        const currentIndex = this._stepClickCount % steps.length;

        for (let i = 0; i <= currentIndex; i++) {
            steps[i].classList.add('active');
        }

        this._stepClickCount++;

        if (this._stepClickCount > steps.length) {
            this._stepClickCount = 0;
            steps.forEach((step) => {
            step.classList.remove('active');
            });
        }
    }

    bigger_text(name, e) {
        const classes = ["bigger_text_0", "bigger_text_1", "bigger_text_2"];
        let currentSize = -1;
        this.moveSteps(e)

        for (let i = 0; i < classes.length; i++) {
            if (document.body.classList.contains(classes[i])) {
                currentSize = i;
                break;
            }
        }

        document.body.classList.remove(classes[currentSize]);
        document.body.classList.add(classes[currentSize + 1]);
    }

    hotspot() {
        if(!this.active['hotspot']) {
            document.removeEventListener('hotspot', this.events['hotspot'].bind(this));
        }
        
        this._hostpots.forEach(((el) => el.classList.toggle('hidden')));
        this._modalService.close(this.modal, null);
    }

    destroy() {
        this._removeListener();
    }
}
